import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { getTrainers, updatePackage } from "../../redux/actions/api/apiAction";
import { createPackage } from "../../redux/actions/api/apiAction";
import { store } from "../../redux/storeConfig/store";
import { convertToSeconds, generatePtGroupTiersObj } from "./utils";
import { toastr } from "react-redux-toastr";
const renderStep = (step, values, errors, touched, setFieldValue, trainers) => {
  switch (step) {
    case 1:
      //console.log("step 1");
      return (
        <FormFirstStep
          errors={errors}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
        />
      );
  }
};

function MultiStepForPackage({
  title,
  price,
  memberShipType,
  pt,
  session,
  duration,
  days,
  mode,
  description,
  capacity,
  courtDurations,
  disableOnlineBooking,
  waitingList,
  waitingListCapacity,
  waitingListRule,
  freeTrial,
  allowCancellation,
  allowUnPaidBooking,
  cancelationWindowUnit,
  cancelBefore,
  lastCancellationTimeInSeconds,
  extraPersonFee,
  tiers,
  supportInsurance
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getTrainers(
        1,
        1000,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
  }, [dispatch]);
  let { trainers } = useSelector((state) => state.trainer);
  const [step, setStep] = useState(1);
  const [back, setBack] = useState(0);
  const handleSubmit = async (values) => {

    // Validation for PT packages with capacity > 1
    if(values?.memberShipType === "pt" && values.capacity > 1) {
     const {valid,reason,tiers}= generatePtGroupTiersObj({pricingType:values.pricingType,extraPersonFee:values.extraPersonFee,price:values.price,capacity:values.capacity,tiers:values.tiers})
     if(!valid) return toastr.error(reason)
     values.tiers=tiers
    }
    let requestJson = {
      name: values.title,
      sessionCount: values.session.toString(),
      planType: values.memberShipType,
      price: values.price,
      type: values.mode,
      durationType: values.duration,
      durationCount: values.days,
      hasClassessAccess: values.hasClassessAccess,
      allowTransfereBookings: values?.allowTransfereBookings,
      courts: values?.courts?.length ? values.courts.map(c => c.value) : [],
      sharedBetweenFamily: values?.sharedBetweenFamily,
      isforTrainerOnly: values.isforTrainerOnly,
      gender: values.gender,
      requiredAttachment: values.requiredAttachment,
      sharedBranches: values.sharedBranches,
      poolAccessType: values.poolAccessType,
      capacity: values.capacity,
      count: values.session.toString(),
      courtDurations: values.courtDurations,
      disableOnlineBooking: values.disableOnlineBooking,
      waitingList: values.waitingList,
      waitingListCapacity: values.waitingListCapacity,
      waitingListRule: values.waitingListRule,
      freeTrial: values.freeTrial,
      allowCancellation: values.allowCancellation,
      allowUnPaidBooking: values.allowUnPaidBooking,
      cancelationWindowUnit: values.cancelationWindowUnit,
      cancelBefore: values.cancelBefore,
      lastCancellationTimeInSeconds: convertToSeconds(
        values.cancelBefore,
        values.cancelationWindowUnit
      ),
      tiers:values.tiers,
      hasGroupPricing:values.tiers.length?true:false,
      supportInsurance:values.supportInsurance
    };
    const { packageEdit, editFields } = store.getState().sidebar;
    if (packageEdit) {
      await store.dispatch(updatePackage(requestJson, editFields.id));
    } else {
      await store.dispatch(createPackage(requestJson));
    }
  };

  const submit = (values, actions) => {
    if (values.duration === "M") values.days *= 30;
    handleSubmit(values);
  };

  const formSchema1 = Yup.object().shape({
    title: Yup.string()
      .max(100, "cannot be > 100 characters")
      .required("Title is required"),
    price: Yup.number()
      .required("Price is required")
      .min(0, "Price must be a non-negative integer"),
    memberShipType: Yup.string().required("Select membership type"),
    duration: Yup.string().required("Select any duration"),
    session: Yup.string().required("Session is required"),
    days: Yup.number()
      .required("Duration is required")
      .positive("Duration must be positive integer")
      .integer("Duration must be positive integer"),
  });

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          title,
          price,
          memberShipType,
          pt,
          session,
          duration,
          days,
          mode,
          mixation: "single",
          hasClassessAccess: false,
          allowTransfereBookings: false,
          sharedBetweenFamily: false,
          isforTrainerOnly: false,
          isSharedPackage: false,
          courts: [],
          packageBranchesSharingType: "sharedForCustomBranches",
          sharedBranches: [],
          poolAccessType: null,
          capacity,
          courtDurations,
          disableOnlineBooking,
          waitingList,
          waitingListCapacity,
          waitingListRule,
          freeTrial,
          allowCancellation,
          allowUnPaidBooking,
          cancelationWindowUnit,
          cancelBefore,
          lastCancellationTimeInSeconds,
          extraPersonFee,
          tiers,
          supportInsurance
        }}
        onSubmit={submit}
        validationSchema={formSchema1}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur,
          values,
          setFieldValue,
        }) => (
          <Form>
            {renderStep(step, values, errors, touched, setFieldValue, trainers)}
            <StepButton step={step} />
          </Form>
        )}
      </Formik>
    </>
  );
}

MultiStepForPackage.defaultProps = {
  edit: false,
  price: "",
  title: "",
  session: "unlimited",
  pt: "",
  memberShipType: "GYM",
  duration: "D",
  days: "",
  mode: "OFFLINE",
  gender: "",
  requiredAttachment: false,
  sharedBranches: [],
  capacity: "",
  courtDurations: [],
  disableOnlineBooking: false,
  waitingList: "",
  waitingListCapacity: "",
  waitingListRule: "auto",
  freeTrial: false,
  allowCancellation: true,
  supportInsurance:false,
  allowUnPaidBooking: false,
  cancelationWindowUnit: "d",
  cancelBefore: "",
  lastCancellationTimeInSeconds: "",
  extraPersonFee:0,
  tiers:[],
  handleSubmit: (values) => {},
};

export default MultiStepForPackage;
